import { Link } from "react-router-dom";

import "./PageNotFound.scss";

export const REMOVED_USER = "REMOVED_USER";
export const NOT_FOUND = "NOT_FOUND";
export const REMOVED_GIF = "REMOVED_GIF";

const PAGE_TITLE: { [x: string]: string } = {
  [REMOVED_USER]: "User Deleted",
  [NOT_FOUND]: "Page Not Found",
  [REMOVED_GIF]: "GIF Deleted",
};

export const PageNotFound = ({ pageType = NOT_FOUND }) => {
  return (
    <div className="content common-wrapper not-found">
      <div className="wrapper">
        <div className="logo-404"/>
        <h1 className="text-centered">{PAGE_TITLE[pageType]}</h1>
        <p className="text-centered">
            We’re sorry but the requested page cannot be found. Return to the&nbsp;
          <Link to="/">Homepage</Link> now.
        </p>
      </div>
    </div>
  );
};
